<template>
  <transition name="slide-fade">
    <notifications
      position="top right"
      :ignoreDuplicates="true"
      :max="1"
      animation-type="velocity"
    >
      <template slot="body" slot-scope="props">
        <div
          class="notifications"
          :class="notificationTypeClass(props.item.data)"
        >
          <a class="close" data-dismiss="alert" @click="props.close">
            <svg
              width="9"
              height="11"
              viewBox="0 0 9 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L8.33966 10.6585" stroke="#24282C" />
              <path d="M8.33984 1L1.00019 10.6585" stroke="#24282C" />
            </svg>
          </a>
          <div class="notification-container">
            <div class="notification-icon">
              <img :src="notificationTypeIcon(props.item.data)" />
            </div>
            <div class="notification-content">
              <h5>{{ props.item.title }}</h5>
              <ul>
                <li
                  v-for="(message, index) in props.item.data.messages"
                  :key="index"
                >
                  {{ message }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </transition>
</template>

<script>
export default {
  name: 'Notification',
  methods: {
    notificationTypeClass(data) {
      return `notification-${data.classType}`
    },
    notificationTypeIcon(data) {
      return require(`../assets/${data.icon}.svg`)
    }
  }
}
</script>

<style lang="scss">
@import '@/global.scss';

.notifications {
  width: 41%;
  float: right;
  padding: 15px;
  margin: 20px -1px;
  pointer-events: all;
  border-radius: 49px 0 0 49px;
  border: 1px solid black;

  &.notification-error {
    background: $alert-red;
    color: $onyx;
    border-color: none;
  }

  &.notification-success {
    background-color: $alert-green;
    color: $onyx;
    border-color: none;
  }

  &.notification-warning {
    background-color: $alert-yellow;
    color: $onyx;
    border-color: none;
  }

  &.notification-info {
    background-color: $alert-grey;
    color: $onyx;
    border-color: none;
  }

  .close {
    float: right;
    line-height: 1;
    text-decoration: none;
  }

  .notification-container {
    display: flex;
    align-items: center;
    padding: 0.5rem;
  }

  .notification-content {
    font-family: $inter;
    width: 100%;
    margin: 0 1rem;
    text-align: left;

    ul {
      display: flex;
      flex-direction: column;
      text-align: left;
      list-style-type: none;
      margin: 0;
      padding: 0;

      li {
        font-size: 0.813rem;
        line-height: $body-lineheight-base;
      }
    }
  }

  h5 {
    margin: 0;
    font-family: $editorial;
    font-weight: normal;
    font-size: 1.25rem;
    padding-bottom: 4px;
  }

  p {
    margin: 0;
  }

  @media (max-width: 575.98px) {
    border-radius: 0;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    border-radius: 0;
  }
}
</style>
